import { render, staticRenderFns } from "./folder-dropdown.vue?vue&type=template&id=09c877e3"
import script from "./folder-dropdown.vue?vue&type=script&lang=js"
export * from "./folder-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports